import { useSingleTeam } from "../../hooks"
import { TeamDetail } from "../../types/team.types"

export const TeamInfo = ({id, attribute }: {id?: string, attribute: keyof TeamDetail}) => {
    const {singleTeamData, isLoading} = useSingleTeam(id)

    if(isLoading) return <>...</>
    if(!singleTeamData) return <>-</>

    const value = singleTeamData[attribute] as any
    return (
        
            <>{value}</>
        
    )
}